import { useUiFramework } from '../../providers/UiFrameworkProvider'

import { RecurrencePeriod as LegacyRecurrencePeriod } from './legacy/RecurrencePeriod'
import { RecurrencePeriod as TidalRecurrencePeriod } from './tidal/RecurrencePeriod'

export function RecurrencePeriod() {
  const uiFramework = useUiFramework()

  switch (uiFramework) {
    case 'legacy':
      return <LegacyRecurrencePeriod />

    case 'tidal':
      return <TidalRecurrencePeriod />
  }
}
